import type { AllRouteEndpoints } from "../../routeTypes";
export const postEngagementCanvasCacheKeys: AllRouteEndpoints[] = ["/engagement/canvas_data(/:workflow_id)"];
